module.exports = __webpack_public_path__ + "img/33_fineStaff_yb.15704dc2.png";